import { useState } from 'react';
import { RichTextArea, Stack, Text } from 'shell/components';
import { stripHTML } from 'utils/helper';

const RichTextAreaDemo = () => {
    const [value, setValue] = useState('');

    return (
        <>
            <Text variant={'sh1'}>RichTextArea</Text>
            <Stack spacing={4}>
                <RichTextArea
                    label={'Controlled with static border'}
                    labelId={'rich-text-area-controlled-static'}
                    value={value}
                    variant={'static'}
                    onChange={setValue}
                />
                <RichTextArea
                    error={Boolean(!value.length)}
                    helperText={`${stripHTML(value).length} characters`}
                    helperTextPosition={'end'}
                    label={'With validation'}
                    labelId={'rich-text-area-validation'}
                    value={value}
                    variant={'static'}
                    onChange={setValue}
                />
                <RichTextArea
                    label={'Controlled with dynamic border'}
                    labelId={'rich-text-area-controlled-dynamic'}
                    value={value}
                    variant={'dynamic'}
                    onChange={setValue}
                />
                {/* <RichTextArea
                    defaultValue={value}
                    label={'Uncontrolled with dynamic border'}
                    labelId={'rich-text-area-uncontrolled-dynamic'}
                    variant={'dynamic'}
                    onBlur={console.log}
                /> */}
            </Stack>
        </>
    );
};

export default RichTextAreaDemo;
